import {type} from '@clients/shared/utilities';
import {Action} from '@clients/shared/models';
import { MultilingualData } from '@clients/member-direct/translation';

export const MemberDirectConfigActionTypes = {
    RESET: type('[member-direct-config] reset'),

    SET_CONFIG: type('[member-direct-config] set config prop'),

    SET_DEFAULT_LANGUAGE: type('[member-direct-config] set default language'),
    SET_LANGUAGE: type('[member-direct-config] set language'),
    SET_IS_NEXT_GEN: type('[member-direct-config] set is next gen'),
    SET_IS_MOVE_PAGE: type('[member-direct-config] set is move page'),
    SET_FOOTER: type('[member-direct-config] set footer'),
};

export class ResetMemberDirectConfigAction implements Action {
    public type = MemberDirectConfigActionTypes.RESET;
}

interface SetConfigPropActionPayload {
    prop: string;
    value: any;
}

export class SetConfigAction implements Action<SetConfigPropActionPayload> {
    public type = MemberDirectConfigActionTypes.SET_CONFIG;

    constructor(public payload: SetConfigPropActionPayload) {}
}

export class SetDefaultLanguageAction implements Action<string> {
    public type = MemberDirectConfigActionTypes.SET_DEFAULT_LANGUAGE;

    constructor(public payload: string) {}
}

export class SetAppLanguageAction implements Action<string> {
    public type = MemberDirectConfigActionTypes.SET_LANGUAGE;

    constructor(public payload: string) {}
}

export class SetIsNextGenAction implements Action<boolean> {
    public type = MemberDirectConfigActionTypes.SET_IS_NEXT_GEN;

    constructor(public payload: boolean) {}
}

export class SetIsMovePageAction implements Action<boolean> {
    public type = MemberDirectConfigActionTypes.SET_IS_MOVE_PAGE;

    constructor(public payload: boolean) {}
}

export class SetFooterAction implements Action<MultilingualData<string>> {
    public type = MemberDirectConfigActionTypes.SET_FOOTER;

    constructor(public payload: MultilingualData<string>) {}
}
